module.exports = __webpack_public_path__ + "img/siemens.07423761.jpg";